

















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { GetFileInfo } from "@/services/files/fileService";
import { FileInfo, MediaType } from "@/services/files/types";
import { FILEENDPOINT } from "@/app.config";
import FilePreviewModal from "@/components/files/modals/FilePreviewModal.vue";

@Component({
    components: {
        "file-preview-modal": FilePreviewModal
    }
})
export default class FileInfoSection extends Vue {
    @Prop() fileId!: string;
    @Prop() mediaType!: MediaType;
    fileInfo = {} as FileInfo;
    extension = "";

    mediaTypes = MediaType;
    loading = true;

    // watcher
    @Watch("fileId", { immediate: true, deep: true })
    onFileChanged(value: any, oldValue: any) {
        GetFileInfo(this.fileId).then(response => {
            this.fileInfo = response;
            const nameParts = response.name.split(".");
            this.extension = nameParts[nameParts.length - 1];
        });

        if (this.mediaType === this.mediaTypes.Video) {
            this.loadVideo();
        }
    }

    // computed
    get fileSrc(): string {
        return `${FILEENDPOINT}${this.fileId}`;
    }

    // methods
    loadVideo() {
        const scope = this;
        Vue.nextTick(function () {
            const video = scope.$refs.video as HTMLVideoElement;
            video.autoplay = true;
            video.onloadeddata = () => {
                scope.loading = false;
            };
            video.src = scope.fileSrc;
        });
    }

    close() {
        this.$emit("closeInfo");
    }

    filePreview() {
        const video = this.$refs.video as HTMLVideoElement;
        if (video) {
            video.pause();
        }
        (this.$refs.filePreviewModal as any).open(this.fileId, this.mediaType, this.fileInfo.name);
    }
}
